import "../styles/TestDeletePopup.css"
import {deleteFile} from "./API.jsx"
import Spinner from "./Spinner/Spinner.jsx"
import trash from "../assets/delete.svg"
import { useState } from "react"
import { cacheFiles } from "../util/FileCacheUtil"

function TestDeletePopup (props) {
    const [deleting, setDeleting] = useState(false)

    const handleDelete = async () => {
        setDeleting(true)
        try {
            // A pill can represent a draw assembled from several panel sheets, so
            // delete every source file behind it. Falls back to the single key.
            const keys = (props.fileKeys?.length ? props.fileKeys : [props.fileKey || props.filename]).filter(Boolean);

            // Key format: "userId/filename.json" -> deleteFile wants just "filename.json"
            // Pass patientId when deleting in doctor view mode
            for (const key of keys) {
                await deleteFile(key.split('/').pop(), props.patientId)
            }

            // Remove from local state and update cache instead of calling refreshUserFiles
            if (props.userFiles && props.setUserFiles) {
                props.setUserFiles(prevFiles => {
                    const updatedFiles = prevFiles.filter(file => !keys.includes(file.key));
                    const cacheId = props.patientId || props.userId;
                    if (cacheId) cacheFiles(cacheId, updatedFiles);
                    return updatedFiles;
                });
            }

            // Switch to "all" view after deletion
            if (props.setSelectedFile) {
                props.setSelectedFile("all");
            }

            props.setDeletePopup(false)
        } catch (error) {
            console.error("Delete failed:", error);
            alert("Failed to delete file: " + error.message);
        } finally {
            setDeleting(false)
        }
    }

    const handleClose = () => {
        if (deleting) return
        
        props.setDeletePopup(false)
    }

    return (
        <div className="testDeleteContainer" onClick={e => {handleClose()}}>
            <div className="testDeletePopup" onClick={e => {e.stopPropagation()}}>
                <div className="imageContainer">
                    <img src={trash} />
                </div>
                <h3>Are you sure you want to delete delete this blood test?</h3>
                <div className="actions">
                    {deleting ?
                    <Spinner size={24} color="#272727ff" />
                    :
                    <>
                        <button className="cancel" onClick={() => {handleClose()}}>Cancel</button>
                        <button className="confirm" onClick={() => {handleDelete()}}>Delete</button>
                    </>}
                </div>
            </div>
        </div>
    );
}

export default TestDeletePopup;